var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenContent4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "94.333px",
    viewBox: "0 0 70 94.333",
    enableBackground: "new 0 0 70 94.333",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F8A99F",
    points: "1,43.969 12.185,93.352 69.192,61.085 55.432,1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FEECEA",
    points: "4.604,45.718 8.819,64.323 30.296,52.166 25.112,29.528  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenContent4);
export default __webpack_public_path__ + "static/media/screen_content4.260dbc765da5447d50d9cbd53668fbd5.svg";
export { ForwardRef as ReactComponent };